var map = {
	"./board1.jpeg": 3657,
	"./board2.jpeg": 8158,
	"./board3.jpeg": 5136,
	"./boardsAll.jpeg": 9450,
	"./boardsLandscape.jpeg": 9668,
	"./coastlines1.jpg": 8853,
	"./coastlines10.jpg": 3836,
	"./coastlines11.jpg": 1016,
	"./coastlines2.jpg": 826,
	"./coastlines3.jpg": 9135,
	"./coastlines4.jpg": 1275,
	"./coastlines5.jpg": 19,
	"./coastlines6.jpg": 3427,
	"./coastlines7.jpg": 2196,
	"./coastlines8.jpg": 1376,
	"./coastlines9.jpg": 2368,
	"./coastlinesLandscape.jpg": 9878,
	"./epoxy1.jpg": 942,
	"./epoxy10.jpg": 6485,
	"./epoxy11.jpg": 9520,
	"./epoxy12.jpg": 6666,
	"./epoxy2.jpg": 3977,
	"./epoxy3.jpg": 8672,
	"./epoxy4.jpg": 7408,
	"./epoxy5.jpg": 1200,
	"./epoxy6.jpg": 3558,
	"./epoxy7.jpg": 3474,
	"./epoxy8.jpg": 4070,
	"./epoxy9.jpg": 1788,
	"./galapagos1.jpg": 3429,
	"./galapagos10.JPG": 3224,
	"./galapagos11.JPG": 3295,
	"./galapagos12.JPG": 4073,
	"./galapagos13.jpg": 5907,
	"./galapagos14.jpg": 2584,
	"./galapagos15.jpg": 7149,
	"./galapagos2.jpg": 3239,
	"./galapagos3.jpg": 5113,
	"./galapagos4.jpg": 8587,
	"./galapagos5.jpg": 2959,
	"./galapagos6.jpg": 1633,
	"./galapagos7.jpg": 3996,
	"./galapagos8.jpg": 188,
	"./galapagos9.jpg": 3869,
	"./nook1.jpeg": 8343,
	"./nook2.jpeg": 1165,
	"./nook3.jpeg": 6661,
	"./squirrels1.jpeg": 9998,
	"./squirrels10.jpeg": 9945,
	"./squirrels11.jpg": 8697,
	"./squirrels12.jpeg": 1802,
	"./squirrels13.jpeg": 6667,
	"./squirrels14.jpg": 530,
	"./squirrels15.jpeg": 8714,
	"./squirrels16.jpeg": 130,
	"./squirrels17.jpeg": 9499,
	"./squirrels2.jpeg": 3506,
	"./squirrels3.jpeg": 1073,
	"./squirrels4.jpeg": 7134,
	"./squirrels5.jpeg": 1035,
	"./squirrels6.jpeg": 7058,
	"./squirrels7.jpeg": 7521,
	"./squirrels8.jpeg": 2830,
	"./squirrels9.jpeg": 9872,
	"./squirrelsLandscape.jpeg": 6212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5556;